import { useNavigate, useLocation } from "react-router-dom";
import { useState, useCallback, useEffect } from "react";
import "./CadastroTrem.css";
import CadastroHeader from "../../../components/CadastroHeader/CadastroHeader";
import { api } from "../../../services/apiService";
import { rotas } from "../../../app/configs/CadastroConfigs";
import Modal from "../../../components/Modal/Modal";
import AppSnackbar from "../../../components/AppSnackbar/AppSnackbar";
import { Box, Button, Paper } from "@mui/material";

import styles from "../../../styles/styles";
function CadastroTrem() {
  const navigate = useNavigate();
  const location = useLocation();
  const tremEdit = location.state?.id != null ? location.state : null;

  const getInitialForm = (trem) => ({
    id: trem?.id ?? null,
    identificacao: trem?.identificacao || "",
    frotaId: trem?.frotaId || "",
    identificadorTrem: trem?.identificadorTrem || "",
    quantidadeCarros: trem?.quantidadeCarros || 0,
  });

  const [modal, setModal] = useState({
    show: false,
    type: "",
    message: "",
  });
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, open: false }));

  const [form, setForm] = useState(getInitialForm(tremEdit));
  const [loading, setLoading] = useState(false);
  const [frotas, setFrotas] = useState([]);

  useEffect(() => {
    api.frota.getAll()
      .then(res => setFrotas(res?.data || res || []))
      .catch(() => { });
  }, []);

  const validateForm = useCallback(() => {
    if (!form.identificacao || !form.frotaId || !form.identificadorTrem)
      return "Preencha os campos obrigatórios antes de salvar!";
    if (form.quantidadeCarros && (isNaN(form.quantidadeCarros) || form.quantidadeCarros < 0 || form.quantidadeCarros > 20))
      return "A quantidade de carros deve ser um número entre 0 e 20!";
    return null;
  }, [form]);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;

    let sanitizedValue = value;

    if (name === 'quantidadeCarros') {
      const numeric = parseInt(value.replace(/[^0-9]/g, ''), 10) || 0;
      sanitizedValue = numeric > 8 ? 8 : numeric;
    } else if (name === 'identificacao') {
      let formatted = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      formatted = formatted.slice(0, 3);
      if (!/^[A-Z][0-9]{0,2}$/.test(formatted) && formatted !== '') {
        return;
      }
      sanitizedValue = formatted;
    } else if (name === 'identificadorTrem') {
      sanitizedValue = value.replace(/[^0-9]/g, '');
    }

    setForm((prev) => ({ ...prev, [name]: sanitizedValue }));
  }, []);

  const handleSave = useCallback(async () => {
    const validationMessage = validateForm();
    if (validationMessage) {
      setModal({ show: true, type: "error", message: validationMessage });
      return;
    }

    try {
      setLoading(true);

      const tremData = {
        nomeCodigo: form.identificacao,
        frotaId: parseInt(form.frotaId),
        identificadorTrem: parseInt(form.identificadorTrem),
        quantidadeCarros: parseInt(form.quantidadeCarros) || 0
      };

      form.id
        ? await api.trem.update(form.id, tremData)
        : await api.trem.create(tremData);

      setSnackbar({
        open: true,
        message: `Trem ${form.id ? "atualizado" : "criado"} com sucesso!`,
        severity: "success",
      });

      setTimeout(() => {
        setModal({ ...modal, show: false });
        navigate(rotas["cadastroPage"], { state: { activeTab: "trem" } });
      }, 2000);

    } catch (error) {
      let mensagemErro = "Erro ao salvar trem.";

      if (error.response) {
        mensagemErro = error.response.data?.mensagem ||
          error.response.data?.error ||
          error.mensagem ||
          mensagemErro;
      } else if (error.request) {
        mensagemErro = "Servidor não respondeu. Verifique sua conexão.";
      } else {
        mensagemErro = error.message || mensagemErro;
      }

      setModal({
        show: true,
        type: "error",
        message: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [form, validateForm, navigate]);

  return (
    <>
      <Box sx={styles.pageWrapper}>


        <Box component="main" sx={styles.mainContent}>

          <Paper elevation={0} sx={styles.card}>

            <CadastroHeader
              title={tremEdit ? "Editar Trem" : "Cadastrar Trem"}
              subtitle={
                tremEdit
                  ? "Edite os dados do trem"
                  : "Adicione um novo trem e relacione-o com seus respectivos dados"
              }
              backRoute={rotas["cadastroPage"]}
              backTab="trem"
            />

            <Modal
              show={modal.show}
              type={modal.type}
              message={modal.message}
              onClose={() => setModal({ ...modal, show: false })}
            />

            <div className="form-card">

              <div className="form-row">

                <div className="form-field-large">

                  <label>Identificação</label>

                  <input
                    type="text"
                    name="identificacao"
                    value={form.identificacao}
                    onChange={handleChange}
                    placeholder="Digite a identificação"
                  />

                  <div className="field-hint">
                    1 letra seguida de até 2 números
                  </div>


                </div>

                <div className="form-field-small">

                  <label>Quantidade de carros</label>

                  <input
                    type="number"
                    name="quantidadeCarros"
                    value={form.quantidadeCarros}
                    onChange={handleChange}
                    min="0"
                    max="20"
                  />

                  <div className="field-hint">
                    Máximo: 8
                  </div>

                </div>

              </div>

              <label>Frota</label>

              <select
                name="frotaId"
                value={form.frotaId}
                onChange={handleChange}
              >
                <option value="" disabled hidden>
                  Selecione a frota
                </option>

                {frotas.map(f => (
                  <option key={f.id} value={f.id}>
                    {f.frota}
                  </option>
                ))}

              </select>

              <label>Identificador do trem</label>

              <input
                type="number"
                name="identificadorTrem"
                value={form.identificadorTrem}
                onChange={handleChange}
                placeholder="Digite o identificador do trem"
              />

              <Button
                type="button"
                onClick={handleSave}
                disabled={loading}
              >
                {loading ? "Salvando..." : "Salvar"}
              </Button>

            </div>

          </Paper>

        </Box>

      </Box>

      <AppSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={closeSnackbar}
      />
    </>

  );

}

export default CadastroTrem;